import { useContext } from "react";
import { MicrophoneContext } from "../providers";

/**
 * Hook that returns the microphone context value
 * 
 * @returns The microphone context
 */
const useMicrophone = () => {
  const microphoneContext = useContext(MicrophoneContext);

  if (!microphoneContext) {
    throw new Error("useMicrophone must be used within an MicrophoneProvider");
  }
  return microphoneContext;
};

export default useMicrophone;
